import { useField } from 'formik';
import React from 'react';
import { FormField, Input, Label } from 'semantic-ui-react';

export default function MyTextInput({ label, ...props }) {
  const [field, meta] = useField(props);
  return (
    <FormField error={meta.touched && !!meta.error}>
      {/* <label>{label}</label> */}
      <Input
        label={label}
        {...field}
        {...props}
        placeholder={label || props.placeholder}
      />
      {meta.touched && meta.error ? (
        <Label basic color='red' style={{ marginTop: '5px' }}>
          {meta.error}
        </Label>
      ) : null}
    </FormField>
  );
}
